import { abort } from "../abort";
import { beforeunload } from "../beforeunload";
import { push } from "../push";
import { processEntry } from "../processEntry";
import { cumulativeLayoutShiftMark } from "../cumulativeLayoutShiftMark";
import { interactionToNextPaintMark } from "../interactionToNextPaintMark";
import { blockingTimeAccumulator } from "../blockingTimeAccumulator";
import { pageMetaData } from "../pageMetaData";
import { speedIndexMark } from "../speedIndexMark";
import { cumulativeResourceMetricsMark } from "../cumulativeResourceMetricsMark";
import type { RUMEntry } from "@fiverr-private/relay-sdk";

/**
 * A list of desired PerformanceEntry.entryType (DOMString)
 * @see PerformanceObserver.supportedEntryTypes for complete list
 */
const entryTypes: Partial<PerformanceObserver["supportedEntryTypes"]> = [
    "first-input",
    "largest-contentful-paint",
    "longtask",
    "mark",
    "navigation",
    "paint",
];

/**
 * Register a new PerformanceObserver to send performance metrics.
 * No params
 */
export async function performanceInformant(): Promise<void> {
    if (abort()) {
        return;
    }
    const metaData = pageMetaData();
    if (!metaData.browser_stats_api || !metaData.pagename) {
        return;
    }

    try {
        const observer = new PerformanceObserver(
            (entryList: PerformanceObserverEntryList) =>
                push(entryList.getEntries().map(processEntry).filter(Boolean)),
        );

        entryTypes.forEach(
            (type) =>
                PerformanceObserver.supportedEntryTypes.includes(type) &&
                observer.observe({ type, buffered: true }),
        );

        beforeunload(
            () =>
                push(
                    [
                        ...cumulativeLayoutShiftMark(),
                        blockingTimeAccumulator.getMark(),
                        speedIndexMark(),
                        ...interactionToNextPaintMark(),
                        ...cumulativeResourceMetricsMark(),
                    ] as RUMEntry[],
                    { immediate: true },
                ),
            { once: true },
        );
    } catch (error) {
        // fail silently
    }
}
